import React, { useState } from 'react'
import logo from '../../assets/general/bluedoorLogo.svg'
import navDots from '../../assets/general/navDots.png'
import { useNavigate } from 'react-router-dom'
import menuIcon from '../../assets/general/menu.svg'
import closeIcon from '../../assets/general/close-icon.svg'
import { Collapse } from 'antd'

const Navbar = ({isContact, setIsContact, setVideoPlay}) => {

  const navigate = useNavigate()

  const [isNavVisible, setIsNavVisible] = useState(false)

  return (

    <div className='w-full flex flex-col' >
      <div  className='w-fit fixed z-50 flex px-6 md:px-12 py-6'>
          <img  onClick={()=> {navigate('/'); setVideoPlay(false)}} className='h-fit drop-shadow-lg' src={logo} alt="" />  
      </div>
        <ul className=' hidden md:flex font-mosk600 h-fit w-fit fixed right-[2vw] top-[3vh] z-50  gap-12 items-center bg-[#171040] text-[#fff] pl-8 pr-5 py-4 rounded-full' >
          <li onClick={()=> {navigate('/'); setVideoPlay(false)}} className='cursor-pointer text-md font-mosk600' >Home</li>
          <div className='dropdown ' >
            <li className='cursor-pointer text-md font-mosk600'>How we see it</li>
            <ul className='flex flex-col absolute  dropdown-content drop-shadow-xl py-3 bg-[#fff] text-[#000] z-50 rounded-md ' >
              <li onClick={()=> navigate('/approach')} className='hover:bg-[#e6e4e1] hover:font-mosk600 px-5 py-2 cursor-pointer text-sm flex gap-1' >Macro <span>Approach</span> </li>
              <li onClick={()=> navigate('/our-approach')} className=' min-w-fit hover:font-mosk600  px-5 py-2 cursor-pointer text-sm flex gap-1 hover:bg-[#e6e4e1]'>Micro <span>Approach</span></li>
            </ul>
          </div>
          <div className='dropdown ' >
            <li className='cursor-pointer text-md font-mosk600'>Our Work</li>
            <ul className='flex flex-col absolute  dropdown-content drop-shadow-xl py-3 bg-[#fff] text-[#000] z-50 rounded-md ' >
              <li onClick={()=> navigate('/projects')} className=' min-w-fit px-5 py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 hover:bg-[#e6e4e1]'>Projects</li>
              <li onClick={()=> navigate('/casestudy/1')} className=' min-w-fit px-5 py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 hover:bg-[#e6e4e1]'>Case <span>Studies</span></li>
            </ul>
          </div>
          <div className='dropdown ' >
            <li className='cursor-pointer text-md font-mosk600'>About Us</li>
            <ul className='flex flex-col absolute  dropdown-content drop-shadow-xl py-3 bg-[#fff] text-[#000] z-50 rounded-md ' >
              <li onClick={()=> navigate('/about-us')} className='hover:bg-[#e6e4e1] hover:font-mosk600  px-5 py-2 cursor-pointer text-sm flex gap-1' >About <span>Us</span> </li>
              <li onClick={()=> navigate('/company')} className=' min-w-fit px-5 py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 hover:bg-[#e6e4e1]'>Human <span>Capital</span></li>
              <li onClick={()=> navigate('/testimonials')} className=' min-w-fit px-5 py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 hover:bg-[#e6e4e1]'>Testimonials</li>
              
            </ul>
          </div>
        
          <div onClick={()=> setIsContact(!isContact)} className='cursor-pointer flex items-start font-mosk600'>
            <div className='bg-[#ff0000] h-[50px] w-[50px] text-sm text-[#fff] p flex items-center justify-center rounded-full leading-none' >Let's <br /> Talk</div>
            <img className='h-[20px] relative left-[-10px] top-[-5px]' src={navDots} alt="" />
          </div>
        </ul>

        <ul className='md:hidden p-2 h-fit w-fit fixed right-[2vw] top-[3vh] z-50 flex gap-12 items-center bg-[#171040] text-[#fff] rounded-full'>
            {
              isNavVisible ?
                <img onClick={()=>setIsNavVisible(false)} className='w-[40px] h-[40px] p-2' src={closeIcon} alt="" />
              :
                <img onClick={()=>setIsNavVisible(true)} className='w-[40px] h-[40px]' src={menuIcon} alt="" />
            }
        </ul>
        <ul className={isNavVisible ? 'flex flex-col gap-3 md:hidden fixed z-20 drop-shadow-lg top-[13vh] w-[65vw] left-[33vw] bg-[#171040] text-[#fff] px-8 py-6 rounded-md' : 'hidden md:hidden absolute top-[15vh] w-[50vw] left-[48vw] bg-[#171040] text-[#fff] px-8 py-6 rounded-md'} >
            <li onClick={()=> {navigate('/'); setIsNavVisible(false)}} className=' font-mosk600 cursor-pointer text-xl flex gap-1' >Home</li>
            
            <Collapse className='flex flex-col gap-3' showArrow= {false}  defaultActiveKey={['0']} ghost items={[
  {
    key: '1',
    label: <p className="text-[#fff] font-mosk600 text-xl">How we see it</p>,
    children: <div className='text-[#fff] !text-lg flex flex-col gap-3'> 
        <li onClick={()=> {navigate('/approach'); setIsNavVisible(false)}} className='     cursor-pointer text-md flex gap-1' >Macro <span>Approach</span>  </li>
        <li onClick={()=> {navigate('/our-approach'); setIsNavVisible(false)}} className=' min-w-fit     cursor-pointer text-md flex gap-1 '>Micro <span>Approach</span></li>
      </div>
    ,
    showArrow: false,
  },
  {
    key: '2',
    label: <p className="text-[#fff] font-mosk600 text-xl">Our Work</p>,
    children: <div className='text-[#fff] !text-lg flex flex-col gap-3'> 
        <li onClick={()=> {navigate('/projects'); setIsNavVisible(false)}} className='     cursor-pointer text-md flex gap-1' >Projects</li>
        <li onClick={()=> {navigate('/casestudy/1'); setIsNavVisible(false)}} className=' min-w-fit cursor-pointer !text-md flex gap-1 '>Case <span>Studies</span></li>
      </div>
    ,
    showArrow: false,
  },
  {
    key: '3',
    label: <p className="text-[#fff] font-mosk600 text-xl">About Us</p>,
    children: <div className='text-[#fff] !text-lg flex flex-col gap-3'> 
        <li onClick={()=> {navigate('/about-us'); setIsNavVisible(false)}} className='     cursor-pointer !text-md flex gap-1' >About <span>Us</span> </li>
        <li onClick={()=> {navigate('/company'); setIsNavVisible(false)}} className=' min-w-fit     cursor-pointer !text-md flex gap-1 '>Human <span>Capital</span></li>
        <li onClick={()=> {navigate('/testimonials'); setIsNavVisible(false)}} className=' min-w-fit     cursor-pointer !text-md flex gap-1 '>Testimonials</li>
      </div>
    ,
    showArrow: false,
  },
]} />
            
            {/* <li onClick={()=> {navigate('/approach'); setIsNavVisible(false)}} className=' hover:font-mosk600 py-2 cursor-pointer text-sm flex gap-1' >Macro <span>Approach</span> </li>
            <li onClick={()=> {navigate('/our-approach'); setIsNavVisible(false)}} className=' min-w-fit hover:font-mosk600  py-2 cursor-pointer text-sm flex gap-1 '>Micro <span>Approach</span></li>
            <li onClick={()=> {navigate('/projects'); setIsNavVisible(false)}} className=' min-w-fit  py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 '>Projects</li>
            <li onClick={()=> {navigate('/casestudy/1'); setIsNavVisible(false)}} className=' min-w-fit  py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 '>Case <span>Studies</span></li>
            <li onClick={()=> {navigate('/about-us'); setIsNavVisible(false)}} className=' hover:font-mosk600   py-2 cursor-pointer text-sm flex gap-1' >About <span>Us</span> </li>
            <li onClick={()=> {navigate('/company'); setIsNavVisible(false)}} className=' min-w-fit  py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 '>Human <span>Capital</span></li>
            <li onClick={()=> {navigate('/testimonials'); setIsNavVisible(false)}} className=' min-w-fit  py-2 hover:font-mosk600  cursor-pointer text-sm flex gap-1 '>Testimonials</li> */}
            <div onClick={()=> {setIsContact(!isContact); setIsNavVisible(false)}} className='cursor-pointer flex items-start pt-1'>
              <p className='bg-[#ff0000] text-[#fff] text-xl font-mosk600 py-3 px-4 flex items-center justify-center rounded-full leading-none' >Let's Talk</p>
            </div>
        </ul>
    </div>
  )
}

export default Navbar
